import { render, staticRenderFns } from "./performance-statistics_admin.vue?vue&type=template&id=327e2578&scoped=true&"
import script from "./performance-statistics_admin.vue?vue&type=script&lang=js&"
export * from "./performance-statistics_admin.vue?vue&type=script&lang=js&"
import style0 from "./performance-statistics_admin.vue?vue&type=style&index=0&id=327e2578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e2578",
  null
  
)

export default component.exports